import { Component, OnInit } from '@angular/core'
import { CpmService } from 'app/service/cpm.service'
import { StoreService } from 'app/service/store.service'
import { FormControl } from '@angular/forms'

@Component({
  selector: 'app-company-ae-symbol',
  templateUrl: './company-ae-symbol.component.html',
  styleUrls: ['./company-ae-symbol.component.scss']
})
export class CompanyAeSymbolComponent implements OnInit {
  searchInputControl = new FormControl()
  securityList = []
  searchResults = []

  constructor(private cpmService: CpmService, private store: StoreService) {
    this.cpmService.getSecurityList().then(response => {
      this.securityList = response.map(x => x.securitySymbol)
    })
  }

  ngOnInit() {
    this.searchInputControl.valueChanges.subscribe(searchValue => {
      const newValueUppercase = searchValue.toUpperCase()
      this.searchResults = this.securityList
        .filter(x => x.startsWith(newValueUppercase))
        .splice(0, 5)
    })
  }

  onEnter(event) {
    if (this.searchInputControl.value === '') {
      return
    }
    const newValueUppercase = this.searchInputControl.value.toUpperCase()
    this.store.setSearchInputBehavior(newValueUppercase)
  }

  onInput(event) {
    // this.reRouteWhenURLNotInSecurityLevel()
    const newValueUppercase = this.searchInputControl.value.toUpperCase()
    if (
      Object.getPrototypeOf(event) === Object.getPrototypeOf(new Event('input'))
    ) {
      this.store.setSearchInputBehavior(newValueUppercase)
      event.target.blur()
      return
    }

    const typingInput = $('#selectResultList option').get(0)
    if (
      typingInput !== undefined &&
      typingInput.innerText === newValueUppercase
    ) {
      this.store.setSearchInputBehavior(newValueUppercase)
    }
  }

  // reRouteWhenURLNotInSecurityLevel() {
  //   if (this.router.url.indexOf('securities-level') < 0) {
  //     this.router.navigate(['/securities-level/excecutive-summary'])
  //   }
  // }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae-symbol/company-ae-symbol.component.ts